export default __webpack_public_path__ + "static/media/pic37.65ca0536.jpg";